import wallet from '../assets/icons/wallet.svg'
import exportIcon from '../assets/icons/export-icon.svg'
import profile from '../assets/icons/profile-icon.svg'
import arrowRight from '../assets/icons/arrowRight.png'
import resident from '../assets/icons/resident-light.svg'
import staff from '../assets/icons/staff-light.svg'
import downloadIcon from '../assets/icons/Download.svg'
import { DashboardStatsData } from '../interfaces/dashboard'

export const getDashboardCardData = (stats: DashboardStatsData) => [
  {
    icon: wallet,
    bgColor: 'bg-[#0853E4]',
    cardBg: 'bg-[#0853E40F]',
    title: 'Wallet Balance',
    subtitle: 'Current balance',
    value: `₦${stats.balance.current.toLocaleString()}`,
    trendText: `${stats.balance.change}%`,
    trendColor: stats.balance.change >= 0 ? 'text-[#069E2D]' : 'text-[#DD2C2F]',
    trendIcon: stats.balance.change >= 0 ? exportIcon : downloadIcon,
  },
  {
    icon: resident,
    bgColor: 'bg-[#7B61FF]',
    cardBg: 'bg-[#7B61FF0F]',
    title: 'Residents',
    subtitle: 'Total residents',
    value: stats.residents.total.toString(),
    trendText: `${stats.residents.change}%`,
    trendColor: stats.residents.change >= 0 ? 'text-[#069E2D]' : 'text-[#DD2C2F]',
    trendIcon: stats.residents.change >= 0 ? exportIcon : downloadIcon,
  },
  {
    icon: staff,
    bgColor: 'bg-[#FFAE1B]',
    cardBg: 'bg-[#FFAE1B0F]',
    title: 'Staffs',
    subtitle: 'Total staff members',
    value: stats.staffs.total.toString(),
    trendText: `${stats.staffs.change}%`,
    trendColor: stats.staffs.change >= 0 ? 'text-[#069E2D]' : 'text-[#DD2C2F]',
    trendIcon: stats.staffs.change >= 0 ? exportIcon : downloadIcon,
  },
  {
    icon: staff,
    bgColor: 'bg-[#259F46]',
    cardBg: 'bg-[#259F460F]',
    title: 'Staff',
    subtitle: 'Recent Logins',
    isProfileCard: true,
    profileImg: profile,
    actionText: 'Staff Profile',
    actionIcon: arrowRight,
  },
]